import React from 'react';
import WrapperContainer from "@/components/WrapperContainer";
import {
    CATEGORIES_PAGE,
    DEFAULT_TEMPLATE_VERSION,
    MOBILE_TEMPLATE_VERSION
} from "@/utils/constants";
import {getCategoriesPageSSRData} from "@/services/categoriesServices";
import cookie from "cookie";
import {getCustomMenu} from "@/services/menuServices";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setAxiosServerConfig} from "@/services/ApiCaller/apiCallerSSR";
import CategoriesPage from "@/components/responsive/categories/CategoriesPage";

const Categories = ({
                        templateVersion,
                        menuItems,
                        aboveMenuItems,
                        mvcUrl,
                        adsenseStatus,
                        blogs, currentPage, context,
                        googleMapsKey,
                        headerTrackingScopeData,
                        footerTrackingScopeData,
                        isDQENormalisationActive,
                        navigationMetaInfosConfigs,
                        octipasPayload,
                        trackingUrlFapi,
                        wordingVersion,
                        showBanners,
                        bannersBlocList,
                        shopCircleVersion,
                        eventListData,
                        catalogList,
                        logoVersion,
                        adaptiveLoadingResources,
                        deviceType,
                        userAgent,
                        mediaContentList,
                        hasCountDown,
                        categoryLevel,
                        relatedContents,
                        label, id, parentsCategories,
                        childrenCategories, metaInfos, pageClassName
                    }) => {
    return (
        <WrapperContainer context={CATEGORIES_PAGE} templateVersion={templateVersion}>
            <CategoriesPage {...{
                menuItems,
                aboveMenuItems,
                mvcUrl,
                adsenseStatus,
                blogs,
                googleMapsKey,
                headerTrackingScopeData,
                footerTrackingScopeData,
                isDQENormalisationActive,
                navigationMetaInfosConfigs,
                octipasPayload,
                trackingUrlFapi,
                wordingVersion,
                showBanners,
                bannersBlocList,
                shopCircleVersion, currentPage, context,
                eventListData,
                catalogList,
                logoVersion,
                adaptiveLoadingResources,
                deviceType,
                userAgent,
                mediaContentList,
                hasCountDown,
                categoryLevel,
                templateVersion, id, parentsCategories,
                relatedContents, label, childrenCategories, metaInfos, pageClassName
            }} />
        </WrapperContainer>
    );
};

export async function getServerSideProps(context) {
    setAxiosServerConfig(context.res)
    const templateVersion = context.req.headers['cloudfront-is-mobile-viewer'] === 'false' ? DEFAULT_TEMPLATE_VERSION : MOBILE_TEMPLATE_VERSION
    const requestUrl = context.req.url.split('?')[0];
    const userAgent = context.req.headers["user-agent"];
    const parsedCookies = context.req.headers.cookie ? cookie.parse(context.req.headers.cookie) : null;
    const cUserID = parsedCookies && parsedCookies.CUserID ? parsedCookies.CUserID : "";
    const result = await Promise.all([
        getCustomMenu(templateVersion, userAgent, null, true, cUserID, true, requestUrl),
        getCategoriesPageSSRData(context.query.id, templateVersion, userAgent, cUserID, requestUrl)
    ]);
    const menuData = result[0];
    const categoriesData = result[1];
    let countDownElement = categoriesData.bannersBlocList?.filter((item, index) => {
        return item.hasCountDown === true
    })
    return {
        props: {
            context: CATEGORIES_PAGE,
            currentPage: CATEGORIES_PAGE,
            menuItems: menuData.menuItems.values,
            aboveMenuItems: templateVersion === DEFAULT_TEMPLATE_VERSION ? menuData.aboveMenuItems.values : [],
            hasCountDown: countDownElement?.length ? true : false,
            mvcUrl: categoriesData.mvcUrl,
            wordingVersion: categoriesData.wordingVersion,
            showBanners: categoriesData.showBanners ? 'true' : 'false',
            bannersBlocList: categoriesData.bannersBlocList ? categoriesData.bannersBlocList : [],
            eventListData: categoriesData.eventListData ? categoriesData.eventListData : [],
            shopCircleVersion: categoriesData.shopCircleVersion,
            blogs: categoriesData.blogs,
            googleMapsKey: categoriesData.googleMapsKey,
            adsenseStatus: categoriesData.adsenseStatus,
            headerTrackingScopeData: categoriesData.headerTrackingScopeData,
            footerTrackingScopeData: categoriesData.footerTrackingScopeData,
            isDQENormalisationActive: categoriesData.isDQENormalisationActive,
            navigationMetaInfosConfigs: categoriesData.navigationMetaInfosConfigs,
            octipasPayload: categoriesData.octipasPayload,
            trackingUrlFapi: categoriesData.trackingUrlFapi,
            logoVersion: categoriesData.logoVersion,
            userAgent: userAgent,
            mediaContentList: categoriesData.mediaContentList,
            adaptiveLoadingResources: categoriesData.adaptiveLoadingResources,
            categoryLevel: categoriesData.categoryLevel,
            label: categoriesData.label,
            relatedContents: categoriesData.relatedContents ? categoriesData.relatedContents : [],
            childrenCategories: categoriesData.childrenCategories ? categoriesData.childrenCategories : [],
            metaInfos: categoriesData.metaInfos ? categoriesData.metaInfos : [],
            id: categoriesData.id,
            parentsCategories: categoriesData.parentsCategories
        }
    };
}

Categories.propTypes =
    {
        context: PropTypes.string,
        mvcUrl: PropTypes.string,
        adaptiveLoadingResources: PropTypes.object
    };

Categories.defaultProps = {
    adaptiveLoadingResources: {
        "Ressource1": {
            "enabledLevels": "Level2,Level3",
            "ressourceName": "Olapic"
        },
        "Ressource2": {
            "enabledLevels": "Level2,Level3",
            "ressourceName": "FlixMedia"
        },
        "Ressource3": {
            "enabledLevels": "Level3",
            "ressourceName": "Adsense"
        },
        "Ressource4": {
            "enabledLevels": "Level1,Level2,Level3",
            "ressourceName": "VideoViewer"
        }
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        templateVersion: ownProps.templateVersion
    }
}
export default connect(mapStateToProps)(Categories);